import { Grid, IconButton, InputBase, Paper } from "@mui/material";
import { useEffect, useState } from "react";
import SearchIcon from '@mui/icons-material/Search';

const SearchBar = (props) => {

    const { data = [], setSearchData, text, search } = props; 

    const [searchTerm, setSearchTerm] = useState("");

    const handleChange = (e) => {
        setSearchTerm(e.target.value);
    };

    const sendSearchData = (results) => {
        setSearchData(results);
        // console.log("Filtered search data:", results); 

    }

    useEffect(() => {
        // console.log("Search term:", searchTerm);
        // console.log("Search:", search);
        let results;
        if (search === "title") {
            results = data.filter(d =>
                d.title?.toLowerCase().includes(searchTerm) || d.title?.includes(searchTerm)
            );
        }
    
        if (search === "user") {
            results = data.filter(d =>
                d.userName?.includes(searchTerm) || d.userName?.toLowerCase().includes(searchTerm)
            );
        }

        if (search === "name") {
            results = data.filter(d =>
                d.catDisplayName?.toLowerCase().includes(searchTerm) || d.catDisplayName?.includes(searchTerm)
            );
        }
    
        if (search === "brName") {
            results = data?.filter(d =>{
                return (
                    d.brName?.includes(searchTerm) || d.brName?.toLowerCase().includes(searchTerm)
                )}
            );
        }
        
        if (search === "privilege") {
            results = data?.filter(d =>{
                return (
                    d.privilegeName?.includes(searchTerm) || d.privilegeName?.toLowerCase().includes(searchTerm)
                )}
            );
        }
        
        if (search === "brPriv") {
            results = data?.filter(d =>
                d.brName?.includes(searchTerm) || d.brName?.toLowerCase().includes(searchTerm)
            );
        }
    
        
        if(data.length !== 0){
            sendSearchData(results)
        }

        sendSearchData(results);
        }, [searchTerm, data, setSearchData, search]);
      

    return (
        <div>
            <div style={{ display: "flex", padding: "20px 0px 30px 0", width: '100%' }}>
                <div
                    style={{
                        width: "60px",
                        height: "40px",
                        backgroundColor: "#9e1618",
                        textAlign: "center",
                        borderRadius: "5px 0 0 5px",
                    }}
                >
                    <IconButton>
                        <SearchIcon aria-label="Search" style={{ color: "white" }} />
                    </IconButton>
                </div>
                <InputBase
                    value={searchTerm}
                    onChange={handleChange}
                    placeholder={text}
                    style={{
                        width: "100%",
                        border: 'solid 1px #757575',
                        padding: '0 0 0 10px'
                    }}
                />
            </div>
        </div>
    );
}

export default SearchBar;